/**
 * Para los inputs 
 *  orden: es el numero de la fila en la que saldra el campo
 *  posicion: para cada fila hay 3 posiciones 1, 2, 3 como un grid
 *  key: es la clave de donde se saca la información a mostrar
 * combinar_hora: indica si es necesario mostrar fecha y hora separados o no
 */
export const configuracion_radicacion_avanzada = {
  inputs: [
    {
      "label": "Tipo documental:",
      "key": "tipo_documental",
      "mostrar": true,
      "orden": 1,
      "posicion": 1
    },
    {
      "label": "Dependencia:",
      "key": "dependencia",
      "mostrar": true,
      "orden": 2,
      "posicion": 1
    },
    {
      "label": "Dependencia envia:",
      "key": "dependencia_envio",
      "mostrar": true,
      "orden": 3,
      "posicion": 1
    },
    {
      "label": "Número de radicado:",
      "key": "radicado",
      "mostrar": true,
      "orden": 4,
      "posicion": 1
    },
    {
      "label": "Fecha:",
      "key": "fecha",
      "mostrar": true,
      "orden": 5,
      "posicion": 1
    },    
    {
      "label": "Hora:",
      "key": "hora",
      "mostrar": true,
      "orden": 6,
      "posicion": 1
    },
    {
      "label": "Número de folios:",
      "key": "folios",
      "mostrar": true,
      "orden": 7,
      "posicion": 1
    }
  ],
  "combinar_hora": true,
  "titulo": "",
  "titulo_posicion": 2,
  "titulo_mostrar": true,
  "mensaje": "",
  "mensaje_posicion": 2,
  "mensaje_mostrar": true,
  "logo": "http://localhost:4200/assets/img/logo.png",
  "logo_mostrar": true,
  "logo_width": "40",
  "logo_height": "40",
  "logo_posicion": 3,
}


// WEBPACK FOOTER //
// ./src/environments/radicacion_avanzada.ts